import { HiDotsVertical } from "react-icons/hi";
import PopoverList, { ActionItem } from "./PopoverList";
import { useRef, useState } from "react";

type Props = {
    actions: ActionItem[]
    data: unknown
}

function ContextMenu(props: Props) {
    const [openContext, setOpenContext] = useState(false)
    const [buttonRect, setButtonRect] = useState<DOMRect | null>(null)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const handleToggle = () => {
        if (!openContext && buttonRef.current) {
            setButtonRect(buttonRef.current.getBoundingClientRect())
        }
        setOpenContext(!openContext)
    }

    return (
        <div className='flex flex-row justify-center'>
            <button
                ref={buttonRef}
                className="p-0 rounded-full bg-transparent text-[#e44131] hover:bg-[#b93527] hover:text-white flex justify-center items-center"
                style={{ height: '36px', width: '36px' }}
                onClick={handleToggle}
            >
                <HiDotsVertical />
            </button>
            <PopoverList open={openContext} onClose={() => setOpenContext(false)} data={props.data} actions={props.actions} anchorRect={buttonRect} />
        </div>
    )
}

export default ContextMenu